var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgItaly(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "800px",
    height: "800px",
    viewBox: "0 0 800 800",
    enableBackground: "new 0 0 800 800",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M516.129,245.161v-90.322H283.871v490.322h232.258V296.774c0-7.126,5.777-12.903,12.903-12.903v-25.807 C521.906,258.064,516.129,252.287,516.129,245.161z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.807,
    y: 153.839,
    fill: "#259245",
    width: 234.258,
    height: 492.322
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.807,
    y: 154.839,
    fill: "#259245",
    width: 232.258,
    height: 490.322
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ED1F34",
    d: "M540.936,646.161V296.774c0-6.563-5.34-11.903-11.903-11.903h-1v-27.807h1 c6.563,0,11.903-5.34,11.903-11.903v-91.322h234.258v492.322H540.936z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ED1F34",
    d: "M541.936,245.161c0,7.126-5.777,12.903-12.903,12.903v25.807c7.126,0,12.903,5.777,12.903,12.903v348.387 h232.258V154.839H541.936V245.161z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.097,129.032H12.903C5.777,129.032,0,134.81,0,141.936v516.129c0,7.126,5.777,12.903,12.903,12.903h774.193 c7.126,0,12.903-5.777,12.903-12.903V141.936C800,134.81,794.223,129.032,787.097,129.032z M774.193,645.161H541.936V296.774 c0-7.126-5.777-12.903-12.903-12.903s-12.903,5.777-12.903,12.903v348.387H283.871V154.839h232.258v90.322 c0,7.126,5.777,12.903,12.903,12.903s12.903-5.777,12.903-12.903v-90.322h232.258V645.161z M25.807,154.839h232.258v490.322H25.807 V154.839z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItaly);
export default __webpack_public_path__ + "static/media/italy.9ef80c6c0e6c3ea2dd3069e18f35ada9.svg";
export { ForwardRef as ReactComponent };